export default __webpack_public_path__ + "media/images/logo_alt-2bd23137b79b9a356095600f19c6d2e8.svg";